import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PageNotFound from "../pages/utility/PageNotFound.jsx";
import { useTheme } from "../hooks/useTheme";

const CanView = ({ children, permissions, plan = [], addons = [], isRoute, mpOnly = false, directOnly = false, appOnly = false, sauceyAdminAlwaysShow = false, webOnly = false, notProspect = false, prospectOnly = false }) => {
  const { user, currentRole, selectedMerchant } = useSelector((state) => state.app);
  const { isDirect, isMP, isApp } = useTheme();
  const isSauceyAdmin = user?.type === "saucey_admin";

  const hasPermission = useMemo(() => {
    if (!user || !currentRole) return false;
    if(!permissions) return true;
    if (permissions === "developer") {
      return user.email === "justin@saucey.com" || user.email === "andrew@saucey.com";
    }
    if (user.type === "saucey_admin") {
      return true;
    }
    if (permissions === "saucey_admin") {
      return false;
    }
    if (permissions === "billing") {
      return currentRole.includes("billing");
    } else if (permissions === "admin") {
      return currentRole.includes("admin");
    } else if (permissions === "manager") {
      return currentRole.includes("manager") || currentRole.includes("admin");
    }
    return false;
  }, [user, currentRole]);

  const hasPlan = useMemo(() => {
    if(!selectedMerchant) return false;
    if(plan.length > 0) {
      if(!plan.includes(selectedMerchant.direct_subscription)) {
        return false;
      }
    }
    return true;
  }, [plan, selectedMerchant]);

  const hasAddons = useMemo(() => {
    if(!selectedMerchant) return false;
    if(addons.length > 0) {
      if(!addons.some(addon => selectedMerchant.direct_addons.includes(addon))) {
        return false;
      }
    }
    return true;
  }, [addons, selectedMerchant]);

  if(appOnly && !isApp) {
    return isRoute ? <PageNotFound /> : null;;
  }
  if(webOnly && isApp) {
    return isRoute ? <PageNotFound /> : null;;
  }
  if(notProspect && user?.type === "prospect") {
    return isRoute ? <PageNotFound /> : null;;
  }
  if(prospectOnly) {
    return user?.type === "prospect" ? children : isRoute ? <PageNotFound /> : null;
  }
  
  if (sauceyAdminAlwaysShow && isSauceyAdmin) {
    return children;
  }
  if(mpOnly && isDirect) return isRoute ? <PageNotFound /> : null;;
  if(directOnly && isMP) return isRoute ? <PageNotFound /> : null;;
  return hasPermission && hasPlan && hasAddons ? children : isRoute ? <PageNotFound /> : null;
};
export default CanView;
